<template>
  <div>
    <div class="mpf-panel">
      <h1 class="mpf-panel__title">Request sent</h1>
      <div class="mpf-panel__body" v-if="actionResponseTime">
        We aim to respond in {{ formatHoursToReadableTime(actionResponseTime) }}, usually by email
        or text.
      </div>
      <div class="mpf-panel__body" v-else>
        We aim to respond as soon as possible, usually by email or text.
      </div>
    </div>
    <p v-if="!actionResponseTime">
      If you don't hear back from us within roughly one week, there may have been an issue with your
      request and you should contact us.
    </p>
    <p class="mpf-heading-s">If your request is an emergency or you're not sure:</p>
    <ul>
      <li v-if="tenant?.localOrganisation.phone">
        call the surgery on
        <!-- NB. Phone needs +44 or relevant country code -->
        <a href="tel:{{ tenant?.localOrganisation.phone }}" class="mpf-link">{{
          tenant?.localOrganisation.phone
        }}</a>
      </li>
      <li v-if="isNhsJurisdiction">
        if the surgery is closed, phone <a href="tel:111">111</a> or go online to
        <a href="https://111.nhs.uk/" target="_blank" rel="noopener noreferrer" class="mpf-link"
          >Get help for your symptoms - NHS 111</a
        >
      </li>
      <li>in an emergency, phone 999 or go to A&amp;E</li>
    </ul>

    <p>You may now close this window.</p>
  </div>
</template>

<script setup lang="ts">
  import { useTenantStore } from '../../stores/useTenantStore';
  import { useUrlSegments } from '../composables/useUrlSegments';
  import { storeToRefs } from 'pinia';
  import { useRouteMetaOverrideStore } from '../../stores/useRouteMetaOverrideStore';
  import { onMounted, onUnmounted } from 'vue';
  import { formatHoursToReadableTime } from '../helpers/dates';
  const tenantStore = useTenantStore();

  const { tenant, actionResponseTime, informationBanner, isNhsJurisdiction } =
    storeToRefs(tenantStore);

  const { firstSegment } = useUrlSegments();
  tenantStore.setActionResponseTime(firstSegment.value);

  const metaOverride = useRouteMetaOverrideStore();
  onMounted(() => {
    tenantStore.setInformationBanner(firstSegment.value);
    if (informationBanner) {
      metaOverride.notificationBanner = {
        title: 'Information',
        text: informationBanner.value,
      };
    }
  });
  onUnmounted(() => {
    metaOverride.clearNotificationBanner();
  });
</script>
